import getInstanceAxios from '../Request';

const baseDomain = process.env.REACT_APP_API_CUSTOMERVIEW_SERVICE;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
